<!-- eslint-disable @typescript-eslint/no-use-before-define -->
<template>
    <va-card class="flex mb-4">
        <va-card-title style="height: 30px; padding: 5px; padding-left: 20px"
            >培训报名</va-card-title
        >
        <va-card-content>
            <a-tabs v-model:activeKey="activeKey">
                <a-tab-pane key="1" tab="新增报名">
                    <template #default>
                        <vxe-form
                            :data="formInputEnroll.formData"
                            :rules="formInputEnroll.formRules"
                            title-align="right"
                            ref="rForm"
                            title-width="60"
                        >
                            <vxe-form-item
                                title="课程名称"
                                field="course_name"
                                span="22"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="formInput.formData.course_name"
                                        placeholder="请输入课程名称"
                                        clearable
                                        disabled
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="2">
                                <template #default>
                                    <vxe-button
                                        @click="selectCourse"
                                        :disabled="allInputDisable"
                                        >选择</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="课程简介"
                                field="description"
                                span="24"
                                title-width="120px"
                            >
                                <vxe-textarea
                                    v-model="formInput.formData.description"
                                    placeholder="课程简介"
                                    maxlength="500"
                                    show-word-count
                                    disabled
                                ></vxe-textarea>
                            </vxe-form-item>

                            <vxe-form-item
                                title="课程等级"
                                field="course_level"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-select
                                        transfer
                                        v-model="
                                            formInput.formData.course_level
                                        "
                                        placeholder="请选择课程等级"
                                        clearable
                                        disabled
                                    >
                                        <vxe-option
                                            value="1"
                                            label="基础课程"
                                        ></vxe-option>
                                        <vxe-option
                                            value="2"
                                            label="中级课程"
                                        ></vxe-option>
                                        <vxe-option
                                            value="3"
                                            label="高级课程"
                                        ></vxe-option>
                                    </vxe-select>
                                </template>
                            </vxe-form-item>

                            <vxe-form-item
                                title="技术分类"
                                field="course_type"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-select
                                        v-model="formInput.formData.course_type"
                                        placeholder="请选择技术分类"
                                        disabled
                                        :options="formInput.courseTypes"
                                    ></vxe-select>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="授课日期开始"
                                field="course_start"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        transfer
                                        v-model="
                                            formInput.formData.course_start
                                        "
                                        placeholder="请输入授课日期开始"
                                        type="date"
                                        disabled
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="授课日期结束"
                                field="course_end"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        transfer
                                        v-model="formInput.formData.course_end"
                                        placeholder="请输入授课日期结束"
                                        type="date"
                                        disabled
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="授课方式"
                                field="teach_method"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-select
                                        transfer
                                        v-model="
                                            formInput.formData.teach_method
                                        "
                                        placeholder="请选择授课方式"
                                        clearable
                                        disabled
                                    >
                                        <vxe-option
                                            value="1"
                                            label="线上"
                                        ></vxe-option>
                                        <vxe-option
                                            value="2"
                                            label="线下"
                                        ></vxe-option>
                                    </vxe-select>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="授课地点"
                                field="location"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="formInput.formData.location"
                                        placeholder="请输入授课地点"
                                        disabled
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="讲师"
                                field="lecturerName"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="
                                            formInput.formData.lecturerName
                                        "
                                        disabled
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>

                            <vxe-form-item
                                title="报名方式"
                                field="enroll_method"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-select
                                        transfer
                                        v-model="
                                            formInput.formData.enroll_method
                                        "
                                        placeholder="请选择报名方式"
                                        clearable
                                        disabled
                                    >
                                        <vxe-option
                                            value="1"
                                            label="CoE门户"
                                        ></vxe-option>
                                        <vxe-option
                                            value="2"
                                            label="公司OA"
                                        ></vxe-option>
                                    </vxe-select>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="报名日期开始"
                                field="enroll_start"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        transfer
                                        v-model="
                                            formInput.formData.enroll_start
                                        "
                                        placeholder="请输入报名日期开始"
                                        type="date"
                                        disabled
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="报名日期结束"
                                field="enroll_end"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        transfer
                                        v-model="formInput.formData.enroll_end"
                                        placeholder="请输入报名日期结束"
                                        type="date"
                                        disabled
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>

                            <vxe-form-item
                                title="报名信息"
                                span="4"
                                title-align="left"
                                title-width="200px"
                                :title-prefix="{ icon: 'fa fa-list-alt' }"
                            ></vxe-form-item>
                            <vxe-form-item
                                title="  "
                                span="20"
                                title-align="left"
                                title-width="120px"
                                ><template #default>
                                    <div style="color: red; text-align: start">
                                        可以选择已有需求或者录入全新课题
                                    </div></template
                                >
                            </vxe-form-item>
                            <vxe-form-item
                                title="需求编号"
                                field="require_no"
                                span="10"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="
                                            formInputEnroll.formData.require_no
                                        "
                                        placeholder="请选择需求编号"
                                        clearable
                                        readonly
                                        :disabled="allInputDisable"
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="2">
                                <template #default>
                                    <vxe-button
                                        @click="selectReqs()"
                                        :disabled="allInputDisable"
                                        >选择</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="课题名称"
                                field="require_name"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="
                                            formInputEnroll.formData
                                                .require_name
                                        "
                                        placeholder="请输入课题名称"
                                        clearable
                                        :disabled="allInputDisable"
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="课题描述"
                                field="require_desc"
                                span="24"
                                title-width="120px"
                            >
                                <vxe-textarea
                                    v-model="
                                        formInputEnroll.formData.require_desc
                                    "
                                    placeholder="工作场景描述（流程、痛点、解决方案）"
                                    maxlength="500"
                                    show-word-count
                                    :disabled="allInputDisable"
                                ></vxe-textarea>
                            </vxe-form-item>
                            <vxe-form-item
                                title="课题价值"
                                field="sceneBussValue"
                                span="24"
                                title-width="120px"
                            >
                                <vxe-textarea
                                    v-model="
                                        formInputEnroll.formData.sceneBussValue
                                    "
                                    placeholder="场景业务价值（体验、收益、效率）"
                                    maxlength="500"
                                    show-word-count
                                    :disabled="allInputDisable"
                                ></vxe-textarea>
                            </vxe-form-item>

                            <vxe-form-item
                                title="总部"
                                field="division"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="
                                            formInputEnroll.formData.division
                                        "
                                        placeholder="请输入总部"
                                        disabled
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>

                            <vxe-form-item
                                title="部门"
                                field="dept"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="formInputEnroll.formData.dept"
                                        placeholder="请输入部门"
                                        disabled
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="科室"
                                field="office"
                                span="12"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="
                                            formInputEnroll.formData.office
                                        "
                                        placeholder="请输入科室"
                                        :disabled="allInputDisable"
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item
                                title="科长"
                                field="leader_name"
                                span="10"
                                title-width="120px"
                            >
                                <template #default>
                                    <vxe-input
                                        v-model="
                                            formInputEnroll.formData.leader_name
                                        "
                                        placeholder="请选择科长"
                                        :disabled="allInputDisable"
                                    ></vxe-input>
                                </template>
                            </vxe-form-item>
                            <vxe-form-item span="2">
                                <template #default>
                                    <vxe-button
                                        @click="selectUser(1)"
                                        :disabled="allInputDisable"
                                        >选择</vxe-button
                                    >
                                </template>
                            </vxe-form-item>
                        </vxe-form>
                        <div
                            style="text-align: center; width: 100%"
                            v-if="isViewFooter && activeKey === '1'"
                        >
                            <vxe-button
                                v-if="false"
                                @click="save"
                                icon="fa fa-save"
                                status="success"
                            >
                                保存
                            </vxe-button>
                            <vxe-button
                                :loading="submitting"
                                icon="fa fa-check"
                                @click="submit"
                                status="primary"
                                >提交
                            </vxe-button>
                        </div>
                    </template>
                </a-tab-pane>
                <a-tab-pane key="2" tab="报名历史">
                    <div style="overflow: hidden; height: 100%">
                        <vxe-table
                            stripe
                            class="mytable-scrollbar"
                            :data="tableDataHis"
                            :height="410"
                            show-overflow
                            :row-config="{
                                height: 36,
                                isHover: true,
                                isCurrent: true,
                            }"
                            ref="xTableHis"
                        >
                            <vxe-column
                                type="seq"
                                field="id"
                                title="序号"
                                width="50"
                            ></vxe-column>
                            <vxe-column
                                field="status_name"
                                title="状态"
                                width="100"
                                show-overflow
                                resizable
                                sortable
                            >
                                <template #default="{ row }">
                                    <vxe-button
                                        v-bind:class="{
                                            active:
                                                row.status_name === '已提交',
                                        }"
                                        type="text"
                                        @click="viewEnrollHis(row)"
                                        >{{ row.status_name }}
                                    </vxe-button>
                                </template>
                            </vxe-column>
                            <vxe-column
                                field="course_name"
                                title="课程名称"
                                width="180"
                                show-overflow
                                resizable
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="course_type_name"
                                title="技术分类"
                                width="120"
                                sortable
                            ></vxe-column>
                            <vxe-column
                                field="course_period"
                                title="授课日期"
                                width="190"
                                show-overflow
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="lecturerName"
                                title="讲师"
                                width="100"
                                show-overflow
                                sortable
                                resizable
                            ></vxe-column>
                            <vxe-column
                                field="enroll_time"
                                title="报名时间"
                                width="160"
                                show-overflow
                                resizable
                                sortable
                            ></vxe-column>
                        </vxe-table>
                        <vxe-pager
                            background
                            v-model:current-page="courseTablePager.currentPage"
                            v-model:page-size="courseTablePager.pageSize"
                            :total="courseTablePager.totalResult"
                            @page-change="courseListPageChange"
                            size="small"
                        >
                        </vxe-pager>
                    </div>
                </a-tab-pane>
            </a-tabs>
        </va-card-content>
    </va-card>
    <vxe-modal title="选择用户" v-model="iShowSelectUser" width="640">
        <template #default>
            <div>
                <vxe-form>
                    <vxe-form-item title="关键字" :item-render="{}">
                        <template #default>
                            <vxe-input
                                v-model="userTablePager.searchKey"
                                placeholder="请输入姓名或邮箱"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                @click="findUserData"
                                @keyup.enter="findUserData"
                                >查询</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                </vxe-form>
            </div>
            <div>
                <vxe-table
                    class="mytable-scrollbar"
                    :data="dtUser"
                    ref="xTableUser"
                    height="300"
                    @cell-dblclick="chooseUser"
                    highlight-hover-row
                    highlight-current-row
                >
                    <vxe-column
                        type="seq"
                        field="Id"
                        title="序号"
                        width="50"
                    ></vxe-column>
                    <vxe-column
                        field="UserName"
                        title="姓名"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="JobZb"
                        title="总部"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="JobName"
                        title="部门"
                        width="120"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="UserMail"
                        title="邮箱"
                        width="200"
                        sortable
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="uid"
                        title="uid"
                        width="10"
                        :visible="false"
                    ></vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager
                    background
                    v-model:current-page="userTablePager.currentPage"
                    v-model:page-size="userTablePager.pageSize"
                    :total="userTablePager.totalResult"
                    @page-change="handlePageChangeUser"
                    size="small"
                >
                </vxe-pager>
            </div>
        </template>
    </vxe-modal>
    <vxe-modal title="选择课程" v-model="isShowCourseSel" width="640">
        <template #default>
            <div>
                <vxe-form :data="courseTablePager">
                    <vxe-form-item
                        title="关键字"
                        field="searchKey"
                        :item-render="{}"
                    >
                        <template #default="{ data }">
                            <vxe-input
                                v-model="data.searchKey"
                                placeholder="请输入需求编号、开发编号、数字员工名称"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                @click="findCourseData"
                                @keyup.enter="findCourseData"
                                >查询</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                status="primary"
                                @click="confirmSelectCourse"
                                >选择</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                </vxe-form>
            </div>
            <div>
                <vxe-table
                    class="mytable-scrollbar"
                    :data="dtCourse"
                    ref="xTableCourse"
                    height="300"
                    @cell-dblclick="confirmSelectCourse"
                    highlight-hover-row
                    highlight-current-row
                >
                    <vxe-column
                        type="seq"
                        field="id"
                        title="序号"
                        width="50"
                    ></vxe-column>
                    <vxe-column
                        field="course_name"
                        title="课程名称"
                        width="140"
                        sortable
                        show-overflow
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="course_type_name"
                        title="技术分类"
                        width="180"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="course_period"
                        title="授课日期"
                        width="190"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="teach_method_name"
                        title="授课方式"
                        width="100"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="lecturerName"
                        title="讲师"
                        width="100"
                        sortable
                        show-overflow
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="teach_method_name"
                        title="报名方式"
                        width="100"
                        sortable
                        show-overflow
                    ></vxe-column>
                    <vxe-column
                        field="enroll_period"
                        title="报名期间"
                        width="190"
                        resizable
                        sortable
                        show-overflow
                    ></vxe-column>
                    <vxe-column
                        field="course_level_name"
                        title="课程等级"
                        width="100"
                        sortable
                        show-overflow
                    ></vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager
                    background
                    v-model:current-page="courseTablePager.currentPage"
                    v-model:page-size="courseTablePager.pageSize"
                    :total="courseTablePager.totalResult"
                    @page-change="courseListPageChange"
                    size="small"
                >
                </vxe-pager>
            </div>
        </template>
    </vxe-modal>
    <vxe-modal title="选择需求" v-model="isShowRequireSel" width="640">
        <template #default>
            <div>
                <vxe-form :data="reqTablePager">
                    <vxe-form-item
                        title="关键字"
                        field="searchKey"
                        :item-render="{}"
                    >
                        <template #default="{ data }">
                            <vxe-input
                                v-model="data.searchKey"
                                placeholder="请输入需求编号、开发编号、数字员工名称"
                                clearable
                            ></vxe-input>
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                @click="findReqsData"
                                @keyup.enter="findReqsData"
                                >查询</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                    <vxe-form-item>
                        <template #default>
                            <vxe-button
                                status="primary"
                                @click="confirmSelectReq"
                                >选择</vxe-button
                            >
                        </template>
                    </vxe-form-item>
                </vxe-form>
            </div>
            <div>
                <vxe-table
                    class="mytable-scrollbar"
                    :data="dtReqs"
                    ref="xTableReqs"
                    height="300"
                    @cell-dblclick="confirmSelectReq"
                    highlight-hover-row
                    highlight-current-row
                >
                    <vxe-column
                        type="seq"
                        field="Id"
                        title="序号"
                        width="50"
                    ></vxe-column>
                    <vxe-column
                        field="requireNo"
                        title="需求编号"
                        width="140"
                        sortable
                        show-overflow
                        resizable
                    ></vxe-column>
                    <vxe-column
                        field="processName"
                        title="数字员工名称"
                        width="180"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="processID"
                        title="开发编号"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="processDesc"
                        title="工作场景描述"
                        width="200"
                        show-overflow
                        resizable
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="bussName"
                        title="业务姓名"
                        width="120"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="divison"
                        title="总部"
                        width="100"
                        sortable
                        show-overflow
                    ></vxe-column>
                    <vxe-column
                        field="dept"
                        title="业务部门"
                        width="120"
                        resizable
                        sortable
                        show-overflow
                    ></vxe-column>
                    <vxe-column
                        field="office"
                        title="业务科室"
                        width="120"
                        sortable
                        show-overflow
                    ></vxe-column>
                    <vxe-column
                        field="winMan"
                        title="业务窗口"
                        width="100"
                        sortable
                    ></vxe-column>
                    <vxe-column
                        field="leader"
                        title="业务科长"
                        width="100"
                        sortable
                    ></vxe-column>
                </vxe-table>
            </div>
            <div>
                <vxe-pager
                    background
                    v-model:current-page="reqTablePager.currentPage"
                    v-model:page-size="reqTablePager.pageSize"
                    :total="reqTablePager.totalResult"
                    @page-change="reqListPageChange"
                    size="small"
                >
                </vxe-pager>
            </div>
        </template>
    </vxe-modal>
</template>

<script setup>
import {
    onMounted,
    reactive,
    ref,
    getCurrentInstance,
    defineEmits,
    defineExpose,
} from "vue";
import { VXETable } from "vxe-table";
import Qs from "qs";

const { proxy } = getCurrentInstance();
const activeKey = ref("1");
const formInput = reactive({
    title: "培训报名",
    isShow: false,
    courseTypes: [],
    formData: {
        id: "",
        course_name: "",
        course_level: "",
        course_type: "",
        description: "",
        teach_method: "",
        location: "",
        lecturer: "",
        lecturerName: "",
        enroll_method: "",
        enroll_start: "",
        enroll_end: "",
        course_start: "",
        course_end: "",
        duration_hours: 0,
        status: "0",
        saveButDisable: false,
        submitBtnDisable: false,
    },
    formRules: {
        course_name: [{ required: true, message: "课程名称不能为空" }],
        description: [{ required: true, message: "课程简介不能为空" }],
        course_level: [{ required: true, message: "课程等级不能为空" }],
        course_type: [{ required: true, message: "技术分类不能为空" }],
        location: [{ required: true, message: "授课地点不能为空" }],
        teach_method: [{ required: true, message: "授课方式不能为空" }],
        enroll_method: [{ required: true, message: "报名方式不能为空" }],
        enroll_start: [{ required: true, message: "报名日期开始不能为空" }],
        enroll_end: [{ required: true, message: "报名日期结束不能为空" }],
        course_start: [{ required: true, message: "授课日期开始不能为空" }],
        course_end: [{ required: true, message: "授课日期结束不能为空" }],
        duration_hours: [{ required: true, message: "培训学时不能为空" }],
        lecturerName: [{ required: true, message: "讲师不能为空" }],
    },
});
const formInputEnroll = reactive({
    title: "培训报名",
    isShow: false,
    formData: {
        id: "",
        course_id: "",
        user_id: "",
        dept: "",
        division: "",
        office: "",
        enroll_time: "",
        require_name: "",
        require_desc: "",
        sceneBussValue: "",
        leader_uid: "",
        leader_name: "",
        require_no: "",
        status: "0",
        create_time: "",
        creator: "",
        saveButDisable: false,
        submitBtnDisable: false,
    },
    formRules: {
        dept: [{ required: true, message: "部门不能为空" }],
        division: [{ required: true, message: "总部不能为空" }],
        office: [{ required: true, message: "科室不能为空" }],
        require_name: [{ required: true, message: "课题名称不能为空" }],
        require_desc: [{ required: true, message: "课题描述不能为空" }],
        sceneBussValue: [{ required: true, message: "课题价值不能为空" }],
        leader_name: [{ required: true, message: "科长不能为空" }],
    },
});
let allInputDisable = ref(false);
let isViewFooter = ref(true);
let editType = ref("1");
let isShowRequireSel = ref(false); //发布申请，选择需求
const xTableUser = ref(null);
const tableDataHis = ref([]);
const rForm = ref(null);
let dtReqs = ref([]); //需求列表
const reqTablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
    searchKey: "",
});

const openModal = async () => {
    formInput.formData.id = "";
    formInput.formData.course_name = "";
    formInput.formData.course_level = "";
    formInput.formData.course_type = "";
    formInput.formData.description = "";
    formInput.formData.teach_method = "";
    formInput.formData.location = "";
    formInput.formData.lecturer = "";
    formInput.formData.lecturerName = "";
    formInput.formData.enroll_method = "";
    formInput.formData.enroll_start = "";
    formInput.formData.enroll_end = "";
    formInput.formData.course_start = "";
    formInput.formData.course_end = "";
    formInput.formData.duration_hours = 0;
    formInput.formData.status = "0";

    formInputEnroll.formData = {
        id: "",
        course_id: "",
        user_id: proxy.$store.state.userID,
        dept: proxy.$store.state.jobName,
        division: proxy.$store.state.jobZb,
        office: "",
        enroll_time: "",
        require_name: "",
        require_desc: "",
        sceneBussValue: "",
        require_no: "",
        leader_uid: "",
        leader_name: "",
        status: "0",
        create_time: "",
        creator: proxy.$store.state.userID,
        saveButDisable: false,
        submitBtnDisable: false,
    };

    formInputEnroll.title = "培训报名";
    formInputEnroll.isShow = true;
    allInputDisable.value = false;
    isViewFooter.value = true;
    editType.value = "1";
    const $rForm = rForm.value;

    try {
        if ($rForm) {
            await $rForm.reset();
        }
        // const re = await $rForm.clearValidate();
    } catch (e) {
        console.log(e);
    }
};

let userSelectType = ref(0); //选择用户类型 0 讲师
let userTablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
    searchKey: "",
});
let iShowSelectUser = ref(false);
let isShowCourseSel = ref(false); //发布申请，选择需求
let dtCourse = ref([]); //课程列表
const courseTablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
    searchKey: "",
});
const hisTablePager = reactive({
    currentPage: 1,
    pageSize: 10,
    totalResult: 0,
    searchKey: "",
});

const xTableCourse = ref(null);
const confirmSelectCourse = () => {
    const $table = xTableCourse.value;
    const record = $table.getCurrentRecord();
    if (!record) {
        VXETable.modal.message({ content: "请选择一行数据", status: "info" });
        return;
    }
    //判断当前时间是否在报名时间内
    const now = new Date();
    const enrollStart = new Date(record.enroll_start);
    const enrollEnd = new Date(record.enroll_end);

    // 只保留日期部分
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startDate = new Date(
        enrollStart.getFullYear(),
        enrollStart.getMonth(),
        enrollStart.getDate()
    );
    const endDate = new Date(
        enrollEnd.getFullYear(),
        enrollEnd.getMonth(),
        enrollEnd.getDate()
    );

    if (today < startDate || today > endDate) {
        VXETable.modal.message({
            content: `不在课程开放报名时间【${record.enroll_start.slice(
                0,
                10
            )}－${record.enroll_end.slice(0, 10)}】`,
            status: "info",
        });
        return;
    }

    formInputEnroll.formData.course_id = record.id;
    formInput.formData.course_name = record.course_name;
    formInput.formData.description = record.description;
    formInput.formData.course_level = record.course_level;
    formInput.formData.course_type = record.course_type;
    formInput.formData.course_start = record.course_start;
    formInput.formData.course_end = record.course_end;
    formInput.formData.teach_method = record.teach_method;
    formInput.formData.location = record.location;
    formInput.formData.lecturer = record.lecturer;
    formInput.formData.lecturerName = record.lecturerName;
    formInput.formData.enroll_method = record.enroll_method;
    formInput.formData.enroll_start = record.enroll_start;
    formInput.formData.enroll_end = record.enroll_end;

    isShowCourseSel.value = false;
};
const findHisData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: hisTablePager.currentPage,
        pageSize: hisTablePager.pageSize,
        searchKey: [formInputEnroll.formData.user_id, ""],
    };
    proxy.$api.courseManageAPI
        .getCourseEnrollList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            tableDataHis.value = res.data.Data.dataTable;
        })
        .catch((error) => {
            console.log(error);
        });
};
const courseListPageChange = () => {
    findCourseData();
};
const hisListPageChange = () => {
    findHisData();
};

//选择用户 type 1  领导
const selectUser = (type) => {
    userSelectType.value = type;
    userTablePager.searchKey = "";
    findUserData();
    iShowSelectUser.value = true;
};
let dtUser = ref([]);
const findUserData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: userTablePager.currentPage,
        pageSize: userTablePager.pageSize,
        searchKey: [userTablePager.searchKey, ""],
    };
    proxy.$api.systemManageAPI
        .getUserList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            dtUser.value = res.data.Data.dataTable;
            userTablePager.currentPage = res.data.Data.currentPage;
            userTablePager.pageSize = res.data.Data.pageSize;
            userTablePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};
const chooseUser = () => {
    const $table = xTableUser.value;
    if (!$table) {
        console.error("表格实例未找到");
        return;
    }

    const record = $table.getCurrentRecord(); // 获取当前高亮行
    // 或者用复选框选中行：const record = $table.getCheckboxRecords()[0];

    if (!record) {
        VXETable.modal.message({ content: "请选择一行数据", status: "info" });
        return;
    }
    if (userSelectType.value == 1) {
        formInputEnroll.formData.leader_uid = record.uid;
        formInputEnroll.formData.leader_name = record.UserName;
    }

    iShowSelectUser.value = false;
};
const findReqsData = () => {
    const findStat = "5"; //已审核
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: reqTablePager.currentPage,
        pageSize: reqTablePager.pageSize,
        searchKey: [reqTablePager.searchKey, "1", findStat], //第1个参数，是按创建人查询
    };
    proxy.$api.newRequireManageAPI
        .getRequireList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });

                return;
            }
            // console.log(res.data.Data);
            dtReqs.value = res.data.Data.dataTable;
            reqTablePager.currentPage = res.data.Data.currentPage;
            reqTablePager.pageSize = res.data.Data.pageSize;
            reqTablePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};
const selectReqs = () => {
    findReqsData();
    isShowRequireSel.value = true;
};
const reqListPageChange = () => {
    findReqsData();
};
const xTableReqs = ref(null);
const confirmSelectReq = () => {
    const $table = xTableReqs.value;
    const record = $table.getCurrentRecord();
    if (!record) {
        VXETable.modal.message({ content: "请选择一行数据", status: "info" });
        return;
    }
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [record.Id],
    };
    proxy.$api.requireManageAPI
        .getRequireOne(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            let oneModel = res.data.Data.dataTable[0];
            formInputEnroll.formData.require_name = oneModel.processName;
            formInputEnroll.formData.require_no = oneModel.requireNo;
            formInputEnroll.formData.sceneBussValue = oneModel.sceneBussValue;
            formInputEnroll.formData.require_desc = oneModel.processDesc;
            formInputEnroll.formData.office = oneModel.office;
            formInputEnroll.formData.leader_uid = oneModel.leaderUID;
            formInputEnroll.formData.leader_name = oneModel.leader;
        })
        .catch((error) => {
            console.log(error);
        });
    isShowRequireSel.value = false;
};
const findCourseData = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: courseTablePager.currentPage,
        pageSize: courseTablePager.pageSize,
        searchKey: ["", "", "", "", courseTablePager.searchKey, "1"], //只查询未实施的课程
    };
    proxy.$api.courseManageAPI
        .getCourseList(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            dtCourse.value = res.data.Data.dataTable;
            courseTablePager.currentPage = res.data.Data.currentPage;
            courseTablePager.pageSize = res.data.Data.pageSize;
            courseTablePager.totalResult = res.data.Data.totalResult;
        })
        .catch((error) => {
            console.log(error);
        });
};

const selectCourse = () => {
    findCourseData();
    isShowCourseSel.value = true;
};
//保存新课程
const save = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        return;
    }
    if (formInputEnroll.formData.course_id == "") {
        VXETable.modal.message({ content: "请选择课程", status: "info" });
        return;
    }
    //判断当前时间是否在报名时间内
    const now = new Date();
    const enrollStart = new Date(formInput.formData.enroll_start);
    const enrollEnd = new Date(formInput.formData.enroll_end);
    if (now < enrollStart || now > enrollEnd) {
        VXETable.modal.message({
            content: `不在课程开放报名时间【${formInput.formData.enroll_start.slice(
                0,
                10
            )}－${formInput.formData.enroll_end.slice(0, 10)}】`,
            status: "info",
        });
        return;
    }

    const params = getModel();

    if (formInput.formData.saveButDisable) {
        return;
    }

    //新增
    if (editType.value === "1") {
        proxy.$api.courseManageAPI
            .addCourseEnroll(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
                editType.value = "2"; //
                findHisData();
            })
            .catch((error) => {
                VXETable.modal.alert({ content: error, status: "error" });
                console.log(error);
            });
    } else if (editType.value === "2") {
        //更新
        proxy.$api.courseManageAPI
            .updateCourseEnroll(Qs.stringify(params))
            .then((res) => {
                if (res.data.Success == false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    return;
                }
                VXETable.modal.message({
                    content: "保存成功",
                    status: "success",
                });
                editType.value = "2"; //
                findHisData();
            })
            .catch((error) => {
                VXETable.modal.message({ content: error, status: "error" });
                console.log(error);
            });
    }
};
const getModel = () => {
    const enroll = {
        id: formInputEnroll.formData.id,
        course_id: formInputEnroll.formData.course_id,
        user_id: formInputEnroll.formData.user_id,
        dept: formInputEnroll.formData.dept,
        division: formInputEnroll.formData.division,
        office: formInputEnroll.formData.office,
        require_name: formInputEnroll.formData.require_name,
        require_desc: formInputEnroll.formData.require_desc,
        sceneBussValue: formInputEnroll.formData.sceneBussValue,
        leader_uid: formInputEnroll.formData.leader_uid,
        leader_name: formInputEnroll.formData.leader_name,
        require_no: formInputEnroll.formData.require_no,
        status: formInputEnroll.formData.status,
        creator: formInputEnroll.formData.creator,
    };
    return enroll;
};

let submitting = ref(false);
//提交报名
const submit = async () => {
    const $rForm = rForm.value;
    const formErrMap = await $rForm.validate();
    if (formErrMap) {
        submitting.value = false;
        return;
    }
    //判断当前时间是否在报名时间内
    const now = new Date();
    const enrollStart = new Date(formInput.formData.enroll_start);
    const enrollEnd = new Date(formInput.formData.enroll_end);

    // 只保留日期部分
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const startDate = new Date(
        enrollStart.getFullYear(),
        enrollStart.getMonth(),
        enrollStart.getDate()
    );
    const endDate = new Date(
        enrollEnd.getFullYear(),
        enrollEnd.getMonth(),
        enrollEnd.getDate()
    );

    if (today < startDate || today > endDate) {
        VXETable.modal.message({
            content: `不在课程开放报名时间【${formInput.formData.enroll_start.slice(
                0,
                10
            )}－${formInput.formData.enroll_end.slice(0, 10)}】`,
            status: "info",
        });
        return;
    }

    const type = await VXETable.modal.confirm("您确定要提交报名吗?");

    if (type === "confirm") {
        const data = getModel();

        submitting.value = true;
        proxy.$api.courseManageAPI
            .submitCourseEnroll(Qs.stringify(data))
            .then((res) => {
                if (res.data.Success === false) {
                    VXETable.modal.message({
                        content: res.data.Message,
                        status: "error",
                    });
                    submitting.value = false;
                    return;
                }
                VXETable.modal.message({
                    content: "提交成功",
                    status: "success",
                });
                findHisData();
                formInputEnroll.isShow = false;
                submitting.value = false;
            })
            .catch((error) => {
                VXETable.modal.message({
                    content: error,
                    status: "error",
                });
                submitting.value = false;
                console.log(error);
            });
    }
};
const handlePageChangeUser = () => {
    findUserData();
};

const viewEnrollHis = (row) => {
    formInput.formData.id = row.course_id;
    formInput.formData.course_name = row.course_name;
    formInput.formData.course_level = row.course_level;
    formInput.formData.course_type = row.course_type;
    formInput.formData.description = row.description;
    formInput.formData.teach_method = row.teach_method;
    formInput.formData.location = row.location;
    formInput.formData.lecturer = row.lecturer;
    formInput.formData.lecturerName = row.lecturerName;
    formInput.formData.enroll_method = row.enroll_method;
    formInput.formData.enroll_start = row.enroll_start;
    formInput.formData.enroll_end = row.enroll_end;
    formInput.formData.course_start = row.course_start;
    formInput.formData.course_end = row.course_end;
    formInput.formData.duration_hours = row.duration_hours;
    formInput.formData.teach_method = row.teach_method;
    formInput.formData.is_transfer_xq = row.is_transfer_xq;
    formInputEnroll.formData.id = row.id;
    formInputEnroll.formData.course_id = row.course_id;
    formInputEnroll.formData.user_id = row.user_id;
    formInputEnroll.formData.dept = row.dept;
    formInputEnroll.formData.division = row.division;
    formInputEnroll.formData.office = row.office;
    formInputEnroll.formData.enroll_time = row.enroll_time;
    formInputEnroll.formData.require_name = row.require_name;
    formInputEnroll.formData.require_desc = row.require_desc;
    formInputEnroll.formData.require_no = row.require_no;
    formInputEnroll.formData.sceneBussValue = row.sceneBussValue;
    formInputEnroll.formData.leader_uid = row.leader_uid;
    formInputEnroll.formData.leader_name = row.leader_name;
    formInputEnroll.formData.status = row.status;
    formInputEnroll.formData.create_time = row.create_time;
    formInputEnroll.formData.creator = row.creator;
    activeKey.value = "1";
    editType.value = "2";
    isViewFooter.value = formInput.formData.is_transfer_xq == "0"; //未提交状态可以编辑
    allInputDisable.value = formInput.formData.is_transfer_xq == "1"; //未提交状态可以编辑;
};

// type 1 新增 2 编辑
const editEvent = async (row, type) => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: 1,
        pageSize: 20,
        searchKey: [row.id],
    };
    proxy.$api.courseManageAPI
        .getCourseOne(Qs.stringify(params))
        .then(async (res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            formInput.formData = res.data.Data;

            formInput.title = "编辑课程";
            allInputDisable.value = false;
            isViewFooter.value = true;

            editType.value = "2"; //更新

            formInput.isShow = true;
            const $rForm = rForm.value;
            try {
                if ($rForm) {
                    await $rForm.reset();
                }
                // const re = await $rForm.clearValidate();
            } catch (e) {
                console.log(e);
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
const bindCourseType = () => {
    const params = {
        uid: proxy.$store.state.userID,
        email: proxy.$store.state.email,
        currentPage: "",
        pageSize: "",
        searchKey: ["32"],
    };
    proxy.$api.systemManageAPI
        .getLookupValue(Qs.stringify(params))
        .then((res) => {
            if (res.data.Success == false) {
                VXETable.modal.message({
                    content: res.data.Message,
                    status: "error",
                });
                return;
            }
            // console.log(res.data.Data);
            formInput.courseTypes = [];
            for (const item of res.data.Data) {
                formInput.courseTypes.push({
                    value: item.LookupValueCode,
                    label: item.LookupValueName,
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
};
onMounted(() => {
    setTimeout(() => {
        bindCourseType();
        openModal();
        findHisData();
    }, 10);
});
</script>

<style lang="scss" scoped>
.mytable-style .vxe-body--column.col-red {
    background-color: red;
    color: #fff;
}

.active {
    color: green;
}

.error {
    color: red;
}

.audit {
    color: blue;
}
</style>

<style type="text/css">
td.vxe-body--column {
    vertical-align: middle;
}
</style>
